<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">{{ $route.params.id ? "Edit Pass Blocking Date" : "New Pass Blocking Date" }}
                    </h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Form -->
        <form @submit.prevent="save">
            <div class="form-group row align-items-center">
                <label class="col-md-1 mb-0">Company</label>
                <div class="col-md-5 pl-md-0 fit-content">
                    <span v-if="$route.params.id">{{ company }}</span>
                    <select class="custom-select" v-model="company" @change="getPasses" v-else>
                        <option v-for="(item, i) in companies" :key="i" :value="item.CompanyName">
                            {{ item.CompanyName }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-1 mb-0">Pass</label>
                <div class="col-md-5 pl-md-0 fit-content">
                    <span v-if="$route.params.id">{{ passName }}</span>
                    <select class="custom-select" v-model="passId" v-else>
                        <option value="">All</option>
                        <option v-for="(item, i) in passes" :key="i" :value="item.Id">
                            {{ item.Name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-1 mb-0">Start Date</label>
                <div class="col-md-5 pl-md-0 fit-content">
                    <input type="date" class="form-control" v-model="startDate" required />
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-1 mb-0">End Date</label>
                <div class="col-md-5 pl-md-0 fit-content">
                    <input type="date" class="form-control" :min="startDate" v-model="endDate" required />
                </div>
            </div>
            <div class="form-group row align-items-center">
                <div class="col-md-2">
                    <button type="button" class="btn btn-secondary"
                        @click="$router.push({ name:'managePassBlockingDate'})">
                        <i class="fa fa-reply mr-2"></i>Back
                    </button>
                </div>
                <div class="col-md-1 text-right" style="margin-left:50px">
                    <button type="submit" class="btn btn-primary">
                        <i :class="$route.params.id ? 'fa fa-save' : 'fa fa-plus'"></i>
                        {{ $route.params.id ? "Save" : "Add" }}
                    </button>
                </div>
            </div>
        </form>
        <!-- /Form -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
    data() {
        return {
            companies: [],
            company: config.DEFAULT_COMPANY,
            passes: [],
            passId: "",
            passName: "",
            startDate: "",
            endDate: "",
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
    },

    methods: {
        getPassBlockingDateDetail() {
            let param = {
                Token: this.token,
                Id: this.$route.params.id
            };
            this.$store.state.isLoading = true;
            API.getCorporatePassBlockingDateDetail(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        let data = response.data.record;
                        if (!data) this.$router.replace({ name: "managePassBlockingDate" });
                        this.company = data.Company;
                        this.passId = data.PassId;
                        this.passName = data.PassName;
                        this.startDate = data.StartDateCalendar;
                        this.endDate = data.EndDateCalendar;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getCompanies() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getPasses() {
            this.passId = "";
            let param = {
                Token: this.token,
                Company: this.company
            }
            this.$store.state.isLoading = true;
            API.getCorporatePass(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.passes = response.data.record.filter(c => c.Status == "Active");
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        save() {
            let param = {
                Token: this.token,
                Id: this.$route.params.id,
                Company: this.company,
                PassId: this.passId,
                StartDateInput: this.startDate,
                EndDateInput: this.endDate,
            };
            let confirmationText = "Are you sure you want to " + (this.$route.params.id ? "save" : "add") + " the pass blocking date?";
            this.$swal({
                title: "Are you sure?",
                text: confirmationText,
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.saveCorporatePassBlockingDate(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.$router.replace({ name: "managePassBlockingDate" });
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        }
    },

    created() {
        if (this.role != "admin") {
            this.$router.replace({ name: "home" });
        }
        if (this.$route.params.id) { //edit mode
            this.getPassBlockingDateDetail();
        } else { //add mode
            this.getCompanies();
            this.getPasses();
        }
    }
}
</script>

<style scoped>
.fit-content {
    max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/Corppass/ManagePassBlockingDateDetail.vue